module.exports = __webpack_public_path__ + "img/img3.bf67ee55.png";